import { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";
import { Loader2, Building2, Plus, Save } from "lucide-react";

export default function ProspectCategoriesCard() {
  const [cats, setCats] = useState(null);
  const [saving, setSaving] = useState("");
  const [nw, setNw] = useState({ label: "", color: "#38bdf8" });

  const load = () => api.get("/prospect-categories").then((r) => setCats(r.data)).catch(() => setCats([]));
  useEffect(() => { load(); }, []);

  const setField = (key, field, val) => setCats((cs) => cs.map((c) => (c.key === key ? { ...c, [field]: val } : c)));

  const save = async (c) => {
    setSaving(c.key);
    try { await api.patch(`/prospect-categories/${c.key}`, { label: c.label, color: c.color, order: c.order || 0, active: c.active }); toast.success("Categoria aggiornata"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setSaving(""); }
  };

  const create = async () => {
    if (!nw.label.trim()) { toast.error("Inserisci il nome della categoria"); return; }
    setSaving("__new__");
    try { await api.post("/prospect-categories", { label: nw.label, color: nw.color }); toast.success("Categoria creata"); setNw({ label: "", color: "#38bdf8" }); load(); }
    catch (e) { toast.error(e.response?.status === 409 ? "Categoria già esistente" : formatApiError(e.response?.data?.detail)); } finally { setSaving(""); }
  };

  return (
    <Card className="rounded border-border p-5 mt-6" data-testid="prospect-categories-card">
      <div className="flex items-center gap-2 mb-1"><Building2 className="h-4 w-4" style={{ color: "#FDD003" }} /><h2 className="font-heading font-semibold">Categorie Prospect</h2></div>
      <p className="text-xs text-muted-foreground mb-4">Crea, rinomina e scegli il colore dei marker sulla mappa Prospect.</p>
      {!cats ? <div className="flex h-20 items-center justify-center"><Loader2 className="h-5 w-5 animate-spin text-primary" /></div> : (
        <div className="space-y-3">
          {cats.map((c) => (
            <div key={c.key} className="flex items-center gap-2 flex-wrap" data-testid={`cat-row-${c.key}`}>
              <input type="color" value={c.color} onChange={(e) => setField(c.key, "color", e.target.value)} className="h-9 w-9 rounded border border-border bg-transparent cursor-pointer" data-testid={`cat-color-${c.key}`} />
              <Input value={c.label} onChange={(e) => setField(c.key, "label", e.target.value)} className="flex-1 min-w-[160px]" data-testid={`cat-label-${c.key}`} />
              <div className="flex items-center gap-1.5"><Switch checked={c.active} onCheckedChange={(v) => setField(c.key, "active", v)} data-testid={`cat-active-${c.key}`} /><Label className="text-xs text-muted-foreground">Attiva</Label></div>
              <Button size="sm" variant="outline" onClick={() => save(c)} disabled={saving === c.key} data-testid={`cat-save-${c.key}`}>{saving === c.key ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Save className="h-3.5 w-3.5" />}</Button>
            </div>
          ))}
          <div className="flex items-center gap-2 flex-wrap border-t border-border pt-3">
            <input type="color" value={nw.color} onChange={(e) => setNw((n) => ({ ...n, color: e.target.value }))} className="h-9 w-9 rounded border border-border bg-transparent cursor-pointer" data-testid="cat-new-color" />
            <Input value={nw.label} onChange={(e) => setNw((n) => ({ ...n, label: e.target.value }))} placeholder="Nuova categoria..." className="flex-1 min-w-[160px]" data-testid="cat-new-label" />
            <Button size="sm" onClick={create} disabled={saving === "__new__"} data-testid="cat-new-add">{saving === "__new__" ? <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" /> : <Plus className="h-3.5 w-3.5 mr-1.5" />} Aggiungi</Button>
          </div>
        </div>
      )}
    </Card>
  );
}
